import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    toggle:
      'group/toggle flex cursor-pointer items-center rounded-full group-data-[disabled]/toggle:cursor-not-allowed',
    switch:
      'group-data-[checked]/toggle:bg-bg-main-inversion group-hover/toggle:!bg-brand-primary group-data-[disabled]/toggle:!bg-button-inactive inline-flex h-6 w-10 items-center rounded-full bg-gray-500 transition-colors duration-200 group-data-[disabled]/toggle:cursor-not-allowed',
    dot: 'mx-[3px] size-4.5 rounded-full bg-white transition-transform duration-200 group-data-[checked]/toggle:translate-x-4',
    label:
      'text-bg-main-inversion group-data-[disabled]/toggle:text-text-inactive cursor-pointer pl-2 font-light group-data-[disabled]/toggle:cursor-default',
    helperText: 'text-bg-main-inversion mt-2 text-[12px] font-light'
  },
  variants: {
    checkedView: {
      default: '',
      checkedBackground: {
        toggle: 'data-[checked]:bg-accent p-[6px]'
      }
    },
    error: {
      true: {
        switch: 'bg-gray-500 group-data-[checked]/toggle:bg-gray-500',
        helperText: 'text-error'
      }
    },
    color: {
      green: {
        switch: 'group-data-[checked]/toggle:bg-success'
      }
    }
  }
});
